import { format } from 'owa-localize';
import getTodoRequestHeaders from './getTodoRequestHeaders';

import { GetTasksResponse, isGetTaskResponse, getErrorFromObject } from './GetTasksServiceResponse';
import { trace } from 'owa-trace';
import { makeGetRequest } from 'owa-ows-gateway';

export function makeTodoGetRequest(url: string, actionName: string): Promise<GetTasksResponse> {
    return makeGetRequest(
        url,
        null /* correlationId */,
        false /* returnFullResponse */,
        getTodoRequestHeaders(),
        true /* throwServiceError */,
        undefined /* includeCredentials */,
        actionName
    )
        .then(async (response: JSON) => {
            if (isGetTaskResponse(response)) {
                return response;
            } else {
                throw new Error(
                    format(
                        'The service response {0} is not of the expected GetTaskResponse type',
                        response
                    )
                );
            }
        })
        .catch(err => {
            const errorResponse = getErrorFromObject(err);
            trace.warn(err);
            let response: GetTasksResponse = {
                errorResponse: errorResponse,
                Value: [],
            };
            return response;
        });
}
